import { render, staticRenderFns } from "./FontAwesomeLicenseView.vue?vue&type=template&id=65e83b38&scoped=true"
import script from "./FontAwesomeLicenseView.vue?vue&type=script&lang=js"
export * from "./FontAwesomeLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e83b38",
  null
  
)

export default component.exports